import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X, Search, User, ShoppingCart } from "lucide-react";

import { useDispatch, useSelector } from "react-redux";
import { translations } from "../i18n/translation";

import { Facebook, Instagram, Twitter } from "lucide-react";
import { FaTiktok } from "react-icons/fa";
import { facebooklink, instagramlink } from "./SocialMediaLink";
import { setAuthModalOpen } from "store/features/authModalSlice";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const cartItems = useSelector((state) => state.cart.cart);
  console.log({ cartItems });

  const cartCount =
    cartItems?.reduce((total, item) => total + (item.count || 1), 0) || 0;

  const cartTotal =
    cartItems?.reduce((total, item) => {
      return total + item.price * (item.count || 1);
    }, 0) || 0;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.language.lang);
  const { user } = useSelector((state) => state.user || {});

  const isOpen = useSelector((state) => state.authModal.authModalOpen);

  const t = translations[lang];

  const scrollToSection = (id) => {
    setOpen(false);

    navigate({
      pathname: "/",
      hash: id,
    });
  };

  const goHome = () => {
    setOpen(false);

    if (location.pathname !== "/") {
      navigate("/#hero"); // 👈 go to homepage
      return;
    }

    // If already on homepage → scroll to top
    const el = document.querySelector("#hero");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const MobileMenuDivider = () => (
    <div className="relative my-3 flex items-center justify-center">
      {/* left dotted line */}
      <div className="flex-1 border-t border-dashed border-neonYellow/50"></div>

      {/* center dots */}
      <div className="mx-4 flex items-center gap-1">
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
      </div>

      {/* right dotted line */}
      <div className="flex-1 border-t border-dashed border-gray-600/50"></div>
    </div>
  );

  const goTo = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <nav className="fixed top-0 left-0 w-full h-[80px] bg-dry border-b border-gray-800 z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between p-4">
        {/* LOGO */}
        <img
          src="/saigonstar/logo.webp          "
          width={150}
          className="cursor-pointer"
          onClick={goHome}
        />

        {/* DESKTOP MENU */}
        <div className="hidden md:flex space-x-8 text-sm font-medium text-neonYellow">
          <button
            onClick={() => scrollToSection("#hero")}
            className="hover:text-darkbg hover:animate-neonFlicker  transition text-left"
          >
            {t.home}
          </button>
          <button
            onClick={() => scrollToSection("#intro")}
            className="hover:text-darkbg hover:animate-neonFlicker transition text-left"
          >
            {t.about}
          </button>

          <button
            onClick={() => scrollToSection("#category")}
            className="hover:text-darkbg hover:animate-neonFlicker  transition text-left"
          >
            {t.category}
          </button>

          <button
            onClick={() => navigate("/bookatable")}
            className="hover:text-neonYellow hover:animate-neonFlicker  transition text-left"
          >
            Book a table{" "}
          </button>

          <button
            onClick={() => scrollToSection("#contact")}
            className="hover:text-darkbg hover:animate-neonFlicker  transition text-left"
          >
            {t.contact}
          </button>
          {/* <LanguageToggle /> */}

          {/* ACCOUNT */}
          <button
            className="flex items-center gap-1 transition"
            onClick={() => dispatch(setAuthModalOpen(!isOpen))}
          >
            <User className="w-4 h-4 hover:text-darkbg" />
          </button>

          {/* SEARCH */}
          <button className="hover:text-darkbg transition">
            <Search className="w-5 h-5" />
          </button>

          {/* CART */}
          <button
            className="flex items-center gap-2 bg-neonYellow hover:text-darkbg  text-dry  px-3 py-1.5"
            onClick={() => goTo("/cart")}
          >
            <ShoppingCart className="w-4 h-4 " />
            <span className="text-sm">${cartTotal.toFixed(2)}</span>{" "}
          </button>
        </div>

        {/* MOBILE BURGER ICON */}
        <div className="flex space-x-2 md:hidden">
          <button
            className="relative flex items-center justify-center
               w-10 h-10 rounded-md
               text-neonYellow hover:bg-white/5 transition"
          >
            <User
              className="w-5 h-5"
              onClick={() => dispatch(setAuthModalOpen(!isOpen))}
            />
          </button>
          <button
            className="relative flex items-center justify-center w-10 h-10 rounded-md text-neonYellow"
            onClick={() => goTo("/cart")}
          >
            <ShoppingCart className="w-5 h-5" />

            <span
              className="absolute -bottom-0 left-0 flex items-center justify-center
                   w-5 h-5 text-[11px] font-semibold
                   bg-neonYellow text-darkbg
                   rounded-sm"
            >
              {cartCount}
            </span>
          </button>

          <button className=" text-neonYellow" onClick={() => setOpen(!open)}>
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* MOBILE DROPDOWN MENU */}
      {open && (
        <div className="md:hidden bg-dry border-0 border-gray-800 h-screen">
          <div
            className="h-[90vh] overflow-y-auto
 scrollbar-thin overflow-hidden"
          >
            <div className="flex items-center justify-between px-6 py-5 border-b border-border">
              <button className="text-sm tracking-widest text-neonYellow">
                SEARCH
              </button>
              <button className="text-sm tracking-widest text-neonYellow">
                ACCOUNT
              </button>
            </div>
            <div className="flex flex-col text-sm tracking-widest divide-y divide-border ">
              <button
                onClick={() => scrollToSection("#hero")}
                className="px-6 py-5 text-left tracking-widest text-md text-neonYellow uppercase"
              >
                {t.home}
              </button>
              <button
                onClick={() => scrollToSection("#intro")}
                className="px-6 py-5 text-left tracking-widest text-md text-neonYellow uppercase"
              >
                {t.about}
              </button>

              <button
                onClick={() => scrollToSection("#category")}
                className="px-6 py-5 text-left tracking-widest text-md text-neonYellow uppercase"
              >
                {t.category}
              </button>

              <button
                onClick={() => {
                  navigate("/bookatable");
                  setOpen(false);
                }}
                className="px-6 py-5 text-left tracking-widest text-md text-neonYellow uppercase"
              >
                Book a table{" "}
              </button>

              <button
                onClick={() => scrollToSection("#contact")}
                className="px-6 py-5 text-left tracking-widest text-md text-neonYellow uppercase"
              >
                {t.contact}
              </button>
            </div>
            <div className="px-6 py-10 text-center border-0 border-border space-y-6">
              {/* WRITE */}

              <div className="space-y-1">
                <p className="text-xs tracking-widest text-gray-400 uppercase">
                  Write
                </p>
                <p className="text-sm text-neonYellow">
                  hello.saigonstar@gmail.com
                </p>
              </div>

              {/* VISIT */}
              <div className="space-y-1">
                <p className="text-xs tracking-widest text-gray-400 uppercase">
                  Visit
                </p>
                <p className="text-sm text-neonYellow">
                  184 Clarence Street, Upper Riccarton, Christchurch, New
                  Zealand.
                </p>
              </div>

              {/* CALL */}
              <div className="space-y-1">
                <p className="text-xs tracking-widest text-gray-400 uppercase">
                  Call
                </p>
                <p className="text-sm text-neonYellow">(+64) 3 348 8879 </p>
              </div>
              <MobileMenuDivider />

              {/* SOCIAL ICONS */}
              <div className="flex justify-center gap-6 pt-0 text-gray-400">
                <a
                  href={facebooklink}
                  className="hover:text-neonYellow transition"
                >
                  <Facebook size={18} />
                </a>
                <a
                  href={instagramlink}
                  className="hover:text-neonYellow transition"
                >
                  <Instagram size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
